import React from 'react';
import '../styles/designSystem.css';

/* Bouton péristyle — agréger / détailler (jeu de marque du 2026-08-16).

   La cour de la palestre est PLEINE quand le bloc est replié, et s'évide en
   pivotant quand on l'ouvre : on a zoomé et franchi l'enceinte. Né sur les
   cards de Plan services / Plan produits, il devient le geste commun de tout
   ce qui se replie dans l'application (2026-08-29) — ne pas le redessiner. */
export default function PeristyleToggle({ open, onToggle, title, className = '' }) {
  return (
    <button
      type="button"
      className={`lk-mark${className ? ` ${className}` : ''}`}
      aria-expanded={open}
      title={title}
      onClick={onToggle}
    >
      <svg className={`lk-mark__logo${open ? ' is-open' : ''}`} viewBox="0 0 64 64"
           width="16" height="16" aria-hidden>
        <g fill="none" stroke="currentColor" strokeWidth="7" strokeLinecap="round">
          <path d="M25 52 h-7 a6 6 0 0 1 -6 -6 v-28 a6 6 0 0 1 6 -6 h28 a6 6 0 0 1 6 6 v28 a6 6 0 0 1 -6 6 h-7" />
          <rect className="lk-mark__court" x="24" y="24" width="16" height="16" rx="3"
                fill="currentColor" stroke="none" />
        </g>
      </svg>
    </button>
  );
}
